import { Stack } from '@chakra-ui/react'
import MonthlyReportHeader from '../../../components/MonthlyReportHeader'
import usePurpleBubblesText from '../../../hooks/usePurpleBubblesText'
import PurpleBubbleContent from '../../../components/PurpleBubbleContent'
import MonthlyReportNavButtons from '../../../components/MonthlyReportNavButtons'
import useReportMonthGuard from '../../../hooks/useReportMonthGuard'
import { useSupplementsFormState } from './hooks/useSupplementsFormState'
import { SupplementRegimens } from './components/SupplementRegimens'

export const SupplementsPage = () => {
  const isValidated = useReportMonthGuard()
  const { handleSubmit, lists } = useSupplementsFormState()
  const purpleBubbleContent = usePurpleBubblesText('Step-8')

  if (!isValidated) {
    return null // Don't render anything until month is validated
  }

  return (
    <Stack spacing={4}>
      <form onSubmit={handleSubmit}>
        <MonthlyReportHeader title='Supplements' />
      </form>
      {purpleBubbleContent?.text && (
        <PurpleBubbleContent text={purpleBubbleContent.text} />
      )}
      <SupplementRegimens lists={lists} />
      <form onSubmit={handleSubmit}>
        <MonthlyReportNavButtons />
      </form>
    </Stack>
  )
}
